TrelloModel = require 'app/scripts/models/internal/trello-model'

class CustomFieldOption extends TrelloModel
  typeName: 'CustomFieldOption'
  urlRoot: ->
    customField = @getCustomField()
    "/1/customField/#{ customField.id }/options"

  getCustomField: ->
    @collection.sourceModel

  move: (index) ->
    @update('pos', @getCustomField().calcPos(index, @))
    @collection.sort({ silent: false })
    return

module.exports = CustomFieldOption
